import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { shareInfoApi } from '@/api';
export default {
    async getShareInfo({ hubId = '', hubStatus, hubName }) {
        const params = new QueryParameterBuilder();
        if (hubStatus) {
            params.add('hubStatus', hubStatus);
        }
        if (hubName) {
            params.add('hubName', hubName);
        }
        const response = await shareInfoApi.getShareInfo(hubId, params.build());
        return response.data;
    },
    async getShareInfoConfig({ hubId, agencyHubId, }) {
        const response = await shareInfoApi.getShareInfoConfig(hubId, agencyHubId);
        return response.data;
    },
    async postShareInfoConfig({ hubId = '', shareInfo, }) {
        const response = await shareInfoApi.postShareInfoConfig(hubId, shareInfo);
        return response.data;
    },
};
